import { ConnectionRequestsSchema, ConnectionRequestSchema } from "../schemas/connection-requests";
import { List } from "immutable";
import querystring from "querystring";
import config from "site-config";

export const getQuery = ({
    scope,
    filters,
    __search = "",
    __sort = "created_on",
    __sort_order = "desc",
    __limit = 50,
    onStartFetchPage,
    onConnectionRequestsResult,
}) => {
    if (!filters) {
        return null;
    }

    filters = filters.map((x) => (List.isList(x) ? x.map((obj) => obj.__value || obj) : x));

    const query = {
        __meta: true,
        __fields: "__all",
        __limit,
        ...filters.toJS(),
        sort: __sort,
        sort_order: __sort_order,
    };

    return {
        url: `/api/v3.0/brand/${scope.brand._id}/connection-requests?${querystring.stringify(query)}`,
        schema: ConnectionRequestsSchema,
        nextPage: "",
        force: true,
        start: ({ nextPage }) => {
            onStartFetchPage({ reset: !nextPage });
        },
        completed: (data) => {
            const { transformed, headers, status } = data;
            const nextPage = headers ? headers.next : undefined;
            onConnectionRequestsResult({ result: transformed, next: nextPage, status });
        },
    };
};

export const getNextQuery = (nextPage: string) => {
    return {
        force: true,
        schema: ConnectionRequestsSchema,
        url: nextPage,
    };
};

export const getUserConnectionRequestsQuery = () => {
    return {
        force: true,
        schema: ConnectionRequestsSchema,
        url: "/api/v3.0/connection-requests",
    };
};

export const updateStatus = (id, brandId, status, body = {}) => {
    return {
        schema: ConnectionRequestSchema,
        url: `/api/v3.0/brand/${brandId}/connection-request/${id}/${status}`,
        options: { method: "PATCH" },
        body,
    };
};

export const pendingCount = (brandId) => {
    return {
        url: `/api/v3.0/brand/${brandId}/connection-requests/count`,
        options: { method: "GET" },
    };
};

export const retailerCompanies = (retailerId: string, buyers: string[]) => {
    const queryparams = {
        buyers,
    };
    return {
        url: `/api/v3.0/companies/retailer/${retailerId}?${querystring.stringify(queryparams)}`, // TODO [DD]
        options: { method: "GET" },
    };
};

export const getExport = (brandId: string, filters) => {
    return `${config.api}/api/v3.0/brand/${brandId}/connection-requests/export?${querystring.stringify(filters)}`;
};
